import { render, staticRenderFns } from "./CorrectionLog.vue?vue&type=template&id=2c6e6e56&scoped=true"
import script from "./CorrectionLog.vue?vue&type=script&lang=js"
export * from "./CorrectionLog.vue?vue&type=script&lang=js"
import style0 from "./CorrectionLog.vue?vue&type=style&index=0&id=2c6e6e56&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6e6e56",
  null
  
)

export default component.exports